import React, { PureComponent, Fragment } from 'react';
import injectSheet from 'react-jss';
import { Row, Col, Card, Typography, Spin, Icon, Table, Divider } from 'antd';
const { Title, Text } = Typography;
import CONSTANTS from 'src/constants';
import moment from 'moment';

import CharCompany from './Chart/Company';
import CharRetaurants from './Chart/Retaurants';
import BankBalance from './BankBalance';
import numberWithSpaces from 'src/utils';

import styles from './styles';
import CompanySpent from './CompanySpent/index.js';
//redux
import { getAmountInfotRequest, getTopIncomeRestaurant, getLastFiveRestaurantCreated } from 'src/redux/actions/dashborad';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Router } from 'src/routes';
import Paragraph from 'antd/lib/skeleton/Paragraph';
function mapStateToProps(state) {
	return {
		store: {
			amountInfo: state.dashboard.amountInfo
		}
	};
}

const mapDispatchToProps = dispatch => {
	return {
		action: bindActionCreators(
			{
				// getListCreditDetails
				getAmountInfotRequest,
				getLastFiveRestaurantCreated,
			},
			dispatch
		)
	};
};

@injectSheet(styles)
@connect(
	mapStateToProps,
	mapDispatchToProps
)
export default class TamaLayout extends PureComponent {
	state = {
		loading: false,
		fiveRestaurantCreated: [],
		averageAmountTransaction: []

	};

	componentDidMount() {
		this.handelGetAmountInfo();
	}

	handelGetAmountInfo = () => {
		this.setState({ loading: true });
		this.props.action.getAmountInfotRequest(
			{},
			() => {
				this.setState({ loading: false });
			},
			() => {
				this.setState({ loading: false });
			}
		);
		this.props.action.getLastFiveRestaurantCreated(
			{},
			(data) => {
				this.setState({
					loading: false,
					fiveRestaurantCreated: data
				});
			}
		);

	};

	render() {
		const {
			classes,
			store: {
				amountInfo: { data = {} }
			}
		} = this.props;
		const { loading, fiveRestaurantCreated, averageAmountTransaction } = this.state;
		const date = new Date();
		const monthOfYear = `${date.getMonth() + 1}/${date.getFullYear()}`;
		const listFiveRestaurantCreated = [];
		const listAverageAmountTransaction = [];
		return (
			<div className="gutter-example" style={{ minWidth:1000 }}>
				<Row gutter={24} style={{ marginBottom: '15px' }}>
					<Col span={10} >
						<Spin spinning={loading} >
							<Card bordered={true} style={{ marginBottom: '15px' }}>
								<Title type="secondary" level={4}>
									Total des crédits échangés {moment(data.server_date).format('MM/YYYY')} :
								</Title>
								<Title style={{ color: '#00C68E', padding: 0, margin: 0 }}>
									{data.total_amount_credit_exchange_monthly
										? numberWithSpaces(data.total_amount_credit_exchange_monthly)
										: '0'}{' '}
									<span style={{ fontSize: '15px' }}>{CONSTANTS.CURRENCY}</span>
								</Title>
								<Divider dashed={false} style={{ borderWidth: 2 }} />
								<Title type="secondary" level={4} >
									Aujourd'hui {moment(data.server_date).format('DD/MM/YYYY')} : {' '}
									<span style={{ color: '#00C68E' }}>
										{data.total_amount_credit_exchange_today
											? numberWithSpaces(data.total_amount_credit_exchange_today)
											: '0'}{' '}
										<span style={{ fontSize: '15px' }}>{CONSTANTS.CURRENCY}</span>
									</span>
								</Title>

							</Card>
						</Spin>
						<Row gutter={24} style={{ marginBottom: '15px' }}>
							<Col span={12}>
								<Spin spinning={loading}>
									<Card bordered={true}>
										<Title type="secondary" level={4}>
											Moyenne quotidienne d'utilisation :
										</Title>
										<Title style={{ color: '#00C68E', padding: 0, margin: 0 }}>
											{parseInt(Math.round(data.total_amount_users_logged_in_app_now)) || '0'}{' '}
											<span style={{ fontSize: '15px' }}>/ jour</span>
										</Title>
									</Card>
								</Spin>
							</Col>
							<Col span={12}>
								<Spin spinning={loading}>
									<Card bordered={true}>
										<Title type="secondary" level={4}>
											Moyenne quotidienne des transactions :
										</Title>
										<Title style={{ color: '#00C68E', padding: 0, margin: 0 }}>
											{parseInt(Math.round(data.average_transaction_per_days)) || '0'}{' '}
											<span style={{ fontSize: '15px' }}>transactions / jour</span>
										</Title>
									</Card>
								</Spin>
							</Col>

						</Row>
						<Row gutter={24} style={{ marginBottom: '15px' }}>
							<Col span={24}>
								<Spin spinning={loading}>
									<Card bordered={true}>
										<Title type="secondary" level={4}>
											Montant moyen par transaction :
										</Title>
										<Title style={{ color: '#00C68E', padding: 0, margin: 0 }}>
											{
												data.average_amount_transaction && numberWithSpaces(parseInt(Math.round(data.average_amount_transaction))) || '0'
											}
											{' '}
											<span>{CONSTANTS.CURRENCY}</span>
										</Title>
									</Card>
								</Spin>
							</Col>
						</Row>
					</Col>
					<Col span={12}>
						<Row gutter={24} style={{ marginBottom: '15px' }}>
							<Col span={12}>
								<Spin spinning={loading}>
									<Card bordered={true}>
										<Title type="secondary" level={4}>
											Solde total {moment(new Date).format('DD/MM/YYYY')} :
										</Title>
										<Title style={{ color: '#00C68E', padding: 0, margin: 0 }}>
											{data.total_amount_credit
												? numberWithSpaces(data.total_amount_credit)
												: '0'}{' '}
											<span style={{ fontSize: '15px' }}>{CONSTANTS.CURRENCY}</span>
										</Title>
									</Card>
								</Spin>
							</Col>
							<Col span={12}>
								<Spin spinning={loading}>
									<Card bordered={true}>
										<Title type="secondary" level={4}>
											Solde sociétés{' '} :
										</Title>
										<Title style={{ color: '#00C68E', padding: 0, margin: 0 }}>
											{data.total_amount_company
												? numberWithSpaces(data.total_amount_company)
												: '0'}{' '}
											<span style={{ fontSize: '15px' }}>{CONSTANTS.CURRENCY}</span>
										</Title>
									</Card>
								</Spin>
							</Col>
						</Row>
						<Row gutter={24} style={{ marginBottom: '15px' }}>
							<Col span={12}>
								<Spin spinning={loading}>
									<Card bordered={true}>
										<Title type="secondary" level={4}>
											Solde restaurateurs :
										</Title>
										<Title style={{ color: '#00C68E', padding: 0, margin: 0 }}>
											{data.total_amount_credit_restaurant
												? numberWithSpaces(data.total_amount_credit_restaurant)
												: '0'}{' '}
											<span style={{ fontSize: '15px' }}>{CONSTANTS.CURRENCY}</span>
										</Title>
									</Card>
								</Spin>
							</Col>
							<Col span={12}>
								<Spin spinning={loading}>
									<Card bordered={true}>
										<Title type="secondary" level={4}>
											Solde salariés{' '} :
										</Title>
										<Title style={{ color: '#00C68E', padding: 0, margin: 0 }}>
											{data.total_amount_credit_employee
												? numberWithSpaces(data.total_amount_credit_employee)
												: '0'}{' '}
											<span style={{ fontSize: '15px' }}>{CONSTANTS.CURRENCY}</span>
										</Title>
									</Card>
								</Spin>
							</Col>
						</Row>
                        <Row gutter={24} style={{ marginBottom: '15px' }}>
                            <Col>
                                <Spin spinning={loading}>
                                    <Card bordered={true}>
                                        <BankBalance/>
                                    </Card>
                                </Spin>
                            </Col>
                        </Row>
					</Col>
				</Row>
                <Row gutter={24} style={{ marginBottom: '40px' }}>
                    <Col>
                        <Spin spinning={loading}>
                            <Card bordered={true}>
                                <Title type="secondary" level={4}>
                                    Liste des 5 derniers restaurateurs adhérents :
                                </Title>
                                {fiveRestaurantCreated.forEach(element => {
                                    listFiveRestaurantCreated.push(
                                        <Col span={8} style={{ marginBottom: '15px', color: '#01AD7D', fontWeight: 'bold', fontSize: '15px' }}>
                                            <a href={'/restaurants-detail/' + element.id}>{element.restaurantName}</a>
                                        </Col>
                                    )
                                })
                                }
                                {listFiveRestaurantCreated}
                            </Card>
                        </Spin>
                    </Col>
                </Row>
                <Row gutter={24} style={{ marginBottom: '40px' }}>
                    <Col span={24}>
                        <CompanySpent />
                    </Col>
                </Row>
				<Row gutter={24} style={{ marginBottom: '40px' }}>
					<Col span={12}>
						<CharCompany />
					</Col>
					<Col span={12}>
						<CharRetaurants />
					</Col>
				</Row>
			</div >
		);
	}
}
